module.exports = __webpack_public_path__ + "static/media/about_armenia_2.195fcf14.jpg";